import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  // DARK MODE DISABLED - Always use light theme
  // To re-enable dark mode, restore the localStorage logic below:
  // const savedTheme = localStorage.getItem('tms-theme');
  // return savedTheme || 'dark';
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    // Save theme preference to localStorage
    localStorage.setItem('tms-theme', theme);
    
    // Apply theme class and data-theme attribute to document
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);
    
    if (theme === 'dark') {
      root.classList.add('dark');
      root.classList.remove('light');
    } else {
      root.classList.add('light');
      root.classList.remove('dark');
    }
  }, [theme]);

  const toggleTheme = () => {
    // DARK MODE DISABLED - This function is kept but won't be called from UI
    setTheme(prev => prev === 'dark' ? 'light' : 'dark');
  };

  const isDark = theme === 'dark';

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme, isDark }}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
